import { makeStyles } from "@material-ui/core";
import { colorPalette } from '../../colorPalette';
export const useStyles = makeStyles(() => ({
    content: {
        display: 'inline-flex',
        'align-items': 'center',
    },
    typography: {
        color: colorPalette.gray500,
        fontSize: '14px',
        'font-weight': '600',
        display: 'flex',
        'align-items': 'center',
        'justify-content': 'left',
    },
    sizeSmall: {
        fontSize: '14px',
        'font-weight': '600'
    },
    bullet: {
        width: '3px',
        height: '3px',
        margin: '3px 4px 0 3px',
        'background-color': colorPalette.gray500,
        'border-radius': '100%',
    }
}));
